// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".locale-selector[data-v-38cae4a4]{cursor:pointer}.locale-selector.active[data-v-38cae4a4]{font-weight:700}.locale-selector.white[data-v-38cae4a4]{color:#fff}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
